var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysisConsultationRequirement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F4F5F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4998 29.3333H30.1665C29.7065 29.3333 29.3331 29.7066 29.3331 30.1666V40.1665C29.3331 40.6265 29.7065 40.9999 30.1665 40.9999H33.4998C33.9598 40.9999 34.3332 40.6265 34.3332 40.1665V30.1666C34.3332 29.7066 33.9598 29.3333 33.4998 29.3333Z",
    fill: "#900037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8333 34.3333H23.5C23.04 34.3333 22.6666 34.7066 22.6666 35.1666V40.1666C22.6666 40.6265 23.04 40.9999 23.5 40.9999H26.8333C27.2933 40.9999 27.6667 40.6265 27.6667 40.1666V35.1666C27.6666 34.7066 27.2933 34.3333 26.8333 34.3333Z",
    fill: "#900037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1664 24.3335H36.8331C36.3731 24.3335 35.9998 24.7069 35.9998 25.1668V40.1667C35.9998 40.6267 36.3731 41 36.8331 41H40.1664C40.6264 41 40.9998 40.6267 40.9998 40.1667V25.1668C40.9998 24.7069 40.6264 24.3335 40.1664 24.3335Z",
    fill: "#900037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5113 53.1549L45.5631 43.2066C47.9164 40.3333 49.333 36.6633 49.333 32.6667C49.333 23.4768 41.8565 16.0002 32.6666 16.0002C23.4766 16.0002 16 23.4768 16 32.6667C16 41.8566 23.4766 49.3332 32.6665 49.3332C36.6631 49.3332 40.333 47.9166 43.2064 45.5632L53.1546 55.5115C53.4796 55.8365 53.9063 55.9999 54.333 55.9999C54.7597 55.9999 55.1863 55.8365 55.5113 55.5115C56.163 54.8599 56.163 53.8065 55.5113 53.1549ZM32.6665 46C25.3149 46 19.3332 40.0184 19.3332 32.6667C19.3332 25.3151 25.3149 19.3335 32.6665 19.3335C40.018 19.3335 45.9997 25.3152 45.9997 32.6667C45.9997 40.0183 40.0181 46 32.6665 46Z",
    fill: "#900037"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisConsultationRequirement);
export default __webpack_public_path__ + "static/media/analysis-consultation-requirement.6abd1688897ddc29b9d084feca0a5466.svg";
export { ForwardRef as ReactComponent };